/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
// import * as Reactstrap from 'reactstrap';
import { IRegionTileSelectorViewProps } from './region-tile-selector';

export default (props: IRegionTileSelectorViewProps) => {
    // const { regions, useQueryParameter, queryParameter, checkStoreKiosk } = props.config;
    const { regions, queryParameter, checkStoreKiosk } = props.config;
    const { regionSelectorHeading } = props.resources;

    // Append the queryParameter + store to redirects
    const store_code = props.context.request.query?.store;
    const store_kiosk = props.context.request.query?.kiosk ? true : false;

    return (
        <div className='region-tile-selector'>
            <div className='row'>
                <h4>{regionSelectorHeading}</h4>
            </div>
            <div className='row justify-content-center'>
                {regions?.map((region, index) => (
                    // eslint-disable-next-line react/jsx-key
                    <div
                        className='col-6 col-sm-4 col-md-3 col-lg-2'
                        onClick={() => {
                            if (typeof window !== undefined && region.url !== undefined) {
                                window.location.href =
                                    checkStoreKiosk && store_kiosk
                                        ? `https://${region.url}/loyalty-store-sign-up?${queryParameter}=${store_code}&kiosk=true`
                                        : `https://${region.url}/loyalty-store-sign-up?${queryParameter}=${store_code}`;
                            }
                        }}
                    >
                        <div className='region-tile'>
                            <img src={region.image?.src} alt={region.displayString} className='region-tile-img' />
                            <p className='region-tile-language'>{region.displayString}</p>
                            <p className='region-tile-region'>{region.displaySubString}</p>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};
